import {useEffect} from 'react';
import {useSelector} from 'react-redux';

import type {TipsItem} from '@/services/content/tipsContent.types';
import {selectInitialGuideItemType} from '@/state/selectors/app';
import {setInitialGuideItemType} from '@/state/slices/appSlice';
import {dispatch} from '@/state/store';

import useTipsGuideContent from './useTipsGuideContent';

export const useInitialCardNavigation = (handleCardSelect: (card: TipsItem) => void) => {
    const initialGuideItemType = useSelector(selectInitialGuideItemType);
    const {cards} = useTipsGuideContent();

    useEffect(() => {
        if (!initialGuideItemType || cards.length === 0) return;

        const card = cards.find((c) => c.guideItemType === initialGuideItemType);

        if (card) {
            handleCardSelect(card as TipsItem);
            dispatch(setInitialGuideItemType());
        }
    }, [initialGuideItemType, cards, handleCardSelect]);
};
